module.exports = __webpack_public_path__ + "static/media/pt_tr.b92eef76.svg";